/** Метка изображения по этапам («В улучшение» / «В публикацию» / «Утверждено» / «Брак»). Без импорта api: гоняется node:test. */

export type PickStatus = "picked" | "rejected";
export type Stage = "enhance" | "publish" | "approve";

/** Этап, на который ведёт положительная метка: улучшенное и загруженное (готовое фото) — в публикацию, кадр и клип
 *  проекта — утверждение, остальное — в улучшение. */
export function stageOf(kind: string): Stage {
  if (kind === "enhance" || kind === "upload") return "publish";
  if (kind === "shot" || kind === "clip") return "approve";
  return "enhance";
}

export const STAGE_LABEL: Record<Stage, string> = {
  enhance: "В улучшение",
  publish: "В публикацию",
  approve: "Утверждено",
};

export const STAGE_HINT: Record<Stage, string> = {
  ...STAGE_LABEL,
  enhance: "В улучшение — запустит улучшение ≈ $0.24",
};

/** Подпись метки на изображении данного вида; нет метки — `null`. */
export function markLabel(kind: string, pick: string): string | null {
  if (pick === "picked") return STAGE_LABEL[stageOf(kind)];
  if (pick === "rejected") return "Брак";
  return null;
}

/** Фильтр «В публикацию» плиткой: только изображения с меткой этапа публикации (улучшенное и загруженное),
 *  без исходников и прочих шагов цепочки; порядок сервиса. */
export function publishTiles<T extends { variant_id: number | null; kind: string; pick: string }>(rows: readonly T[]): T[] {
  return rows.filter((r) => r.variant_id !== null && r.pick === "picked" && stageOf(r.kind) === "publish");
}

/** Ответ `…/pick` о запуске улучшения (`enhance`). */
export type EnhanceOutcome = { generation_id: number; started: boolean } | { error: string } | null;

export function enhanceNote(e: EnhanceOutcome): string | null {
  if (!e) return null;
  if ("error" in e) return `улучшение не запущено: ${e.error}`;
  return e.started ? "улучшение запущено" : "уже улучшено";
}
